import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie';



@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.scss']
})
export class TextboxComponent implements OnInit, AfterViewInit {


  @ViewChild('validationForm') validationForm: any = false;

  @Input() formItem: any;
  @Input() formId: any;

  @Input() invalidForm: any;
  @Output() invalidFormChange = new EventEmitter<boolean>();

  isRequired: boolean;
  formTitle: string;
  languageId: number = 1;

  constructor(private cookieService: CookieService) { }

  ngOnInit() {
    delete this.formItem.boolValue;
    this.languageId = Number(this.cookieService.get('formLanguage'));
    this.isRequired = this.formItem.item.isRequired;
  }

  getLabel() {
    try {
        let optionFound = this.formItem.item.itemLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
        if (optionFound?.labelField && optionFound.labelField !== '')
          return optionFound.labelField;
        else {
          return this.formItem.item.itemLabels[0].labelField;
        }
    }
    catch (Exception) {
      console.log("ERROR LABELS");
      return '';
    }
  }

  // Use this cycle because the view has to render the conditionals
  // The HTML <template> (or ng-template) element is a mechanism for holding client-side content
  // that is not to be rendered when a page is loaded but may subsequently be instantiated
  // during runtime using JavaScript.
  ngAfterViewInit() {
    if (this.isRequired) {
      this.validationForm.control.statusChanges.subscribe(() => {
        this.invalidForm = this.validationForm.invalid;
        this.invalidFormChange.emit(this.validationForm.invalid);
      });
    }
  }

}
